import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'react-emotion';
import { colors } from '@cimpress/react-components';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
`;

const StepItem = styled('div')`
  display: flex;
  align-items: center;
`;

const Text = styled('span')`
  font-size: 1.214em;
  line-height: 20px;

  color: ${colors.slate};
`;

const active = css`
  color: ${colors.success.base};
`;

const activeDot = css`
  border: none;
  background-color: ${colors.success.base};
`;

const Dot = styled('span')`
  height: 20px;
  width: 20px;
  border-radius: 50%;
  border: solid ${colors.success.base} 2px;
  display: inline-block;
  margin-right: 30px;
`;

const VerticalLine = styled('span')`
  margin: 10px 0 10px 9px;
  height: 20px;
  width: 2px;
  border: 1px dashed ${colors.success.base};
`;

export const EventSteps = ({ steps, activeIndex }) => {
  const stepsToRender = steps.map((step, idx) => (
    <React.Fragment key={idx}>
      <StepItem>
        <Dot className={activeIndex === idx ? activeDot : ''} />
        <Text className={activeIndex === idx ? active : ''}>{step}</Text>
      </StepItem>
      {idx !== steps.length - 1 && <VerticalLine />}
    </React.Fragment>
  ));

  return <Container>{stepsToRender}</Container>;
};

EventSteps.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.string),
  activeIndex: PropTypes.number
};
